import { observer } from 'mobx-react-lite'

import { ImproveQuality } from 'almanac-ui/icons'
import { useRootStore } from 'stores/RootStore'

import { BaseNextStep } from './BaseNextStep'
import { BlazeIcon } from 'components/BlazeIcon/BlazeIcon'

export const CampaignNextStep = observer(function CampaignNextStep() {
  const { docStore, rightRailPanelStore } = useRootStore()

  const handlePlagiarism = () => {
    docStore?.rightRailStore.setActiveTab(undefined)
    rightRailPanelStore.show('plagiarism')
  }

  return (
    <BaseNextStep
      actionText="Check for plagiarism and SEO"
      icon={<BlazeIcon icon={<ImproveQuality size={28} />} color="var(--blaze-light-orange)" />}
      onPress={handlePlagiarism}
    />
  )
})
